import React, { useRef } from "react";
// import WarningIcon from '@material-ui/icons/Warning';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { } from "pages/redux/actions";
import axios from 'axios';
// import logo from 'assets/img/defu.png';
import Avatar from '@material-ui/core/Avatar';
// import logo2 from 'assets/img/noimage2.jpg';
import { connect } from 'react-redux';
import { useHistory, Link } from "react-router-dom";
import { Button, Card, CardHeader, CardFooter, Modal, CardBody, FormGroup, Container, Row, Input, Col, } from "reactstrap";
// core components
import moment from "moment";
import $ from 'jquery'

// import { createMuiTheme, MuiThemeProvider,  } from "@material-ui/core/styles";
import { makeStyles, createStyles, Theme, withStyles } from "@material-ui/core/styles";
import UserHeader from "components/Headers/UserHeader.js";
import Popover from '@material-ui/core/Popover';
import Image from '@material-ui/icons/Image';
import Afile from '@material-ui/icons/InsertDriveFile';
import Emoji from '@material-ui/icons/InsertEmoticon';
import Picker from 'emoji-picker-react';
import File from '@material-ui/icons/AttachFile';
import Send from '@material-ui/icons/Send';
import CircularProgress from '@material-ui/core/CircularProgress'
import Tooltip from '@material-ui/core/Tooltip'
import Message from '../../components/Self/Message.js'
import { IconButton } from "@material-ui/core"; 
import Search from '@material-ui/icons/Search';
import Refresh from '@material-ui/icons/SyncProblem';
import Close from '@material-ui/icons/Close';


const CTooltip = withStyles({
    tooltip: {
        fontSize: "14px",
        // color: "black",
        // color: props.theme === 'white' ? 'black' : props.theme === 'dark' ? '#adb5bd' : '#adb5bd',
        // backgroundColor: props.theme === 'white' ? 'white' : props.theme === 'dark' ? 'black' : '#16141f',
        // backgroundColor: "white",
        padding: '7px',
        // border: props.theme === 'white' ? '1px solid #e5e6ee' : props.theme === 'dark' ? '1px solid #121212' : '1px solid #121212',
        // border: ,
        // boxShadow: props.theme === 'white' ? '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)' : '0 4px 8px 0 rgba(255, 255, 255, 0.15), 0 6px 20px 0 rgba(255, 255, 255, 0.12)',
    }
})(Tooltip);


const Profile = (props) => {
    const history = useHistory();
    // const location = useLocation();
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    // console.log(props)
    var con;
    if (props) {
        // console.log('yes location')
        // console.log(props);
        // console.log(props.match.params);
        if (props.match.params != null) {
            if (props.match.params.id) {
                // console.log('c')
                console.log(props.match.params.id)
                console.log(props.username)
                if (props.match.params.id === props.username.toString()){
                    history.push({
                        pathname: '/main/home',
                        state:{
                            token: 1,
                            type: 'error',
                            message: 'You cannot message yourselves'
                        }
                    })
                }
                con = props.match.params.id
                // console.log(con)
            }
            else {
                // history.push({
                //     pathname: 'home',
                //     state: {
                //         "token": 1,
                //         "type": "error",
                //         "message": 'Something went wrong'
                //     }
                // })

            }
        }
        else {
            // history.push({
            //     pathname: 'home',
            //     state: {
            //         "token": 1,
            //         "type": "error",
            //         "message": 'Something went wrong'
            //     }
            // })
        }

    }
    else {
        // console.log('nope')
    }
    // console.log(con)

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                maxWidth: 345,
            },
            media: {
                height: 0,
                paddingTop: '56.25%', // 16:9
            },
            expand: {
                '&:hover': {
                    backgroundColor: "transparent"
                },
                transform: 'rotate(0deg)',
                marginLeft: 'auto',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shortest,
                }),
            },
            expandOpen: {
                transform: 'rotate(180deg)',
            },
            offerSelf: {
                width: 'auto',
                // backgroundImage: 'linear-gradient(to right, #ef87be, #ffcee6)',
                float: 'right',
                maxWidth: '90%',
                padding: '5px 20px',
                borderRadius: '30px',
                backgroundColor: '#cbe4f9',
                maxHeight: '350px'
            },
            offerOther: {
                width: 'auto',
                // backgroundImage: 'linear-gradient(to right, #ef87be, #ffcee6)',
                float: 'left',
                maxWidth: '90%',
                padding: '5px 20px',
                borderRadius: '30px',
                backgroundColor: '#f9d8d6',
                maxHeight: '350px'
            },
            fulldiv: {
                width: '100%',
                backgroundColor: '',
                float: 'left',
                marginTop: '5px',
                height: "auto",
                maxHeight: '350px'
            },
            button: { verticalAlign: 'center', float: 'left', fontSize: '15px', marginRight: '10px', marginTop: '0px' },
            para: { float: 'left', marginRight: '10px', fontWeight: 'lighter', backgroundColor: '' },
            seen: { float: 'left', marginRight: '10px', marginBottom: '10px', width: '100%' },
            cond: { width: '100%', marginTop: '10px' },
            condt: { float: 'left', fontWeight: 'lighter', wordWrap: 'break-word',wordBreak: 'break-all' },
            popover: {
                pointerEvents: 'none',
            },
            paper: {
                width: '280px',
                height: '310px',
                backgroundColor: ''
            },
            paper2: {
                width: '80px',
                height: '120px',
                backgroundColor: ''
            },
        }),
    );
    const classes = useStyles();
    const hiddenFileInput = React.useRef(null);
    const hiddenImageInput = React.useRef(null);
    const [emoji, setemoji] = React.useState(false);
    const [file, setfile] = React.useState(false);
    const [loading, setloading] = React.useState(false);
    const [filemodal, setfilemodal] = React.useState(false);
    const [imagemodal, setimagemodal] = React.useState(false);
    const [mess, setmess] = React.useState('');
    const [aname, setaname] = React.useState('');
    const [chatl, setchatl] = React.useState(true);
    const [searchopen, setsearchopen] = React.useState(false);
    const [chats, setChats] = React.useState([]);
    const [aimage, setaimage] = React.useState();
    const [sfile, setsfile] = React.useState({});
    const [simage, setsimage] = React.useState({});
    const [imagename, setimagename] = React.useState('Choose an image');
    const [filename, setfilename] = React.useState('Choose a file');
    // var cid2;
    const titleRef2 = useRef();
    // const [cid, setcid] = React.useState();
    // const [bgim, setbgim] = React.useState();

    let [anchorEl, setAnchorEl] = React.useState();
    const chatContainer = React.useRef();
    const openEmoji = (event) => {
        // console.log(event.screenX);
        if (emoji === true) {
            setemoji(false)
        }
        else {
            setAnchorEl(event.currentTarget);
            setemoji(true)
        }

    };

    let [anchorEl2, setAnchorEl2] = React.useState();

    const handleFile = () => {
        // console.log('entered')
        hiddenFileInput.current.click()
    };

    const handleClosefilemodal = () => {
        setfilemodal(false)
    };
    const handleCloseimagemodal = () => {
        setimagemodal(false)
    };
    const handleChangeFile = (event) => {
        setfile(false)
        setsfile({ file: event.target.files[0] })
        // console.log(event.target.files)
        // setafile(URL.createObjectURL(event.target.files[0]))
        setfilename(event.target.files[0].name)
        // console.log(change)
        setfilemodal(true)
    };
    const handleChangeImage = (event) => {
        setfile(false)
        setsimage({ image: event.target.files[0] })
        // console.log(event.target.files)
        setaimage(URL.createObjectURL(event.target.files[0]))
        setimagename(event.target.files[0].name)
        // console.log(change)
        setimagemodal(true)
    };
    const handleImage = () => {
        // console.log('entered')
        hiddenImageInput.current.click()
    };
    const openFile = (event) => {
        // console.log(event.screenX);
        if (file === true) {
            setfile(false)
        }
        else {
            setAnchorEl2(event.currentTarget);
            setfile(true)
        }

    };


    const RE_URL = /\w+:\/\/\S+/g;

    function linkify(str) {
        let match;
        const results = [];
        let lastIndex = 0;
        while ((match = RE_URL.exec(str))) {
            const link = match[0];
            if (lastIndex !== match.index) {
                const text = str.substring(lastIndex, match.index);
                results.push(
                    <span key={results.length}>{text}</span>,
                );
            }
            results.push(
                <a key={results.length} href={link} rel="noreferrer" target="_blank">{link}</a>
            );
            lastIndex = match.index + link.length;
        }
        if (results.length === 0) {
            return str;
        }
        if (lastIndex !== str.length) {
            results.push(
                <span key={results.length}>{str.substring(lastIndex)}</span>,
            );
        }
        return results;
    }
    const closeEmoji = (event) => {
        setemoji(false)

    };

    const closeFile = (event) => {
        setfile(false)

    };

    const onEmojiClick = (event, emojiv) => {
        // console.log('clicked')
        var gg = mess + emojiv.emoji
        setmess(gg)
    };
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    // var recent = []
    // const [bgImage, setbgImage] = React.useState(logo);
    const [userd, setuserd] = React.useState({});
    const fetchChats = React.useCallback(() => {
        // console.log('fetching')
        if (con !== undefined) {
            // console.log('fetching/......')
            axios.get(process.env.REACT_APP_DOMAIN + "/profile/user=" + con, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response)
                    // console.log(response.data)
                    setuserd(response.data)
                    setaname(response.data.username.substring(0, 1))
                    // setbgim(process.env.REACT_APP_DOMAIN + '' + response.data.photo)
                    // setChats(response.data)
                    // setchatl(false)
                })
                .catch((error) => {
                    console.log(error)
                    settt('error')
                    setSendingdata("Something went wrong")
                    setOpen(true);
                })
            axios.get(process.env.REACT_APP_DOMAIN + "/chats/user=" + props.username + "/ouser=" + con, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response)
                    // console.log(response.data)
                    setChats(response.data)
                    setchatl(false)
                    scrollToMyRef()
                    // console.log(response.data)
                    // console.log(response.data)
                    // console.log(titleRef2.current.offsetTop)
                    // console.log(titleRef.current.scrollTop)
                    // titleRef.current.scrollTop = titleRef2.current.offsetTop
                    // console.log(titleRef.current.scrollTop)
                    // console.log(titleRef.current.scrollTop)
                })
                .catch((error) => {
                    settt('error')
                    setSendingdata("Something went wrong")
                    setOpen(true);
                })
        }
    }, [con,props.token,props.username])
    React.useEffect(() => {
        fetchChats()
    }, [fetchChats])

    const data3 = [];
    if (chats) {
        // console.log(chats)
        chats.map(function (responseData, index) {
            // console.log(responseData)
            data3.push(responseData)
            return(null)
        })
    }
    else {
        data3.push({ 'message': <div className="text-center"><p>Be the first to message</p></div> })
    }
    // console.log(data3)

    const handleEnter = (e) => {
        if (e.keyCode === 13) {
            handleSend();
        }
    };
    const handleSend = () => {
        setloading(true)
        if (con === undefined) {
            settt('error')
            setSendingdata("Please select a chat first")
            setOpen(true);
            setloading(false)
            return 0;
        }
        if (mess === undefined) {
            settt('error')
            setSendingdata("Please type something")
            setOpen(true);
            setloading(false)
            return 0;
        }
        if (mess.length < 1) {
            settt('error')
            setSendingdata("Please type something")
            setOpen(true);
            setloading(false)
            return 0;
        }
        // console.log(mess)
        var inp2 = {
            'message': mess,
            'sender': props.username,
            'receiver': con,
        }
        // console.log(inp2)
        axios.post(process.env.REACT_APP_DOMAIN + '/sendmessage', inp2, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setmess('')
                fetchChats()
                setloading(false)
            })
            .catch((error) => {
                settt('error')
                console.log(error)
                setSendingdata("Something went wrong")
                setOpen(true);
                setloading(false)
            })
        fetchChats()
    };

    const handleSendfile = () => {
        setloading(true)
        if (con === undefined) {
            settt('error')
            setSendingdata("Please select a chat first")
            setOpen(true);
            setloading(false)
            return 0;
        }
        if (sfile.file === undefined) {
            settt('error')
            setSendingdata("Please select File")
            setOpen(true);
            setfilemodal(false)
            setloading(false)
            return 0;
        }
        // console.log('yes')
        let formdata = new FormData();
        // console.log(formdata)
        // console.log(sfile.file)
        if (sfile.file !== undefined) {
            formdata.append('file', sfile.file, filename)
        }
        // console.log(formdata)
        // for (var pair of formdata.entries()) {
            // console.log(pair[0] + ', ' + pair[1]);
        // }
        // console.log(formdata)
        axios.post(process.env.REACT_APP_DOMAIN + '/sendfile/sender=' + props.username + '/receiver=' + con, formdata, { 'headers': { 'Authorization': 'Token ' + props.token, 'Content-type': 'multipart/form-data' } })
            .then((response) => {
                // console.log(response.data)
                setmess('')
                setfilemodal(false)
                fetchChats()
                setloading(false)
            })
            .catch((error) => {
                settt('error')
                // console.log(error)
                setSendingdata("Something went wrong")
                setOpen(true);
                setloading(false)
            })
        fetchChats()
    };

    const handleSendimage = () => {
        setloading(true)
        if (con === undefined) {
            settt('error')
            setSendingdata("Please select a chat first")
            setOpen(true);
            setloading(false)
            return 0;
        }
        if (simage.image === undefined) {
            settt('error')
            setSendingdata("Please select Image")
            setOpen(true);
            setimagemodal(false)
            setloading(false)
            return 0;
        }
        // console.log('yes')
        let formdata = new FormData();
        // console.log(formdata)
        // console.log(simage.image)
        if (simage.image !== undefined) {
            formdata.append('image', simage.image, imagename)
        }
        // console.log(formdata)
        // for (var pair of formdata.entries()) {
            // console.log(pair[0] + ', ' + pair[1]);
        // }
        // console.log(formdata)
        axios.post(process.env.REACT_APP_DOMAIN + '/sendimage/sender=' + props.username + '/receiver=' + con, formdata, { 'headers': { 'Authorization': 'Token ' + props.token, 'Content-type': 'multipart/form-data' } })
            .then((response) => {
                // console.log(response.data)
                setmess('')
                setimagemodal(false)
                fetchChats()
                setloading(false)
            })
            .catch((error) => {
                settt('error')
                console.log(error)
                setSendingdata("Something went wrong")
                setOpen(true);
                setloading(false)
            })
        fetchChats()
    };
    const handleMess = (event) => {
        // console.log(event.target.value)
        setmess(event.target.value);
    };
    // console.log(chatContainer)
    const scrollToMyRef = () => {
        // console.log('entered')
        // console.log(chatContainer)
        // console.log(chatContainer.current.scrollHeight)
        // console.log(chatContainer.current.clientHeight)
        const scroll =
            chatContainer.current.scrollHeight -
            chatContainer.current.clientHeight;
        chatContainer.current.scrollTo(0, scroll);
    };


    const handleOnChange = (event) => {
        // console.log(event.target.value)
        if (event.target.value <= 0) {
            fetchChats()
            return 0;
        }
        var i;
        var input = event.target.value.toLowerCase();
        let x = document.getElementsByClassName('main-message');
        // console.log(x.length)
        if (input.length > 2) {
            for (i = 0; i < x.length; i++) {

                if (!x[i].innerHTML.toLowerCase().includes(input)) {
                    x[i].style.backgroundColor = "transparent";
                    x[i].id=""
                }
                else {
                    x[i].style.backgroundColor = "#EEEEF0";
                    x[i].id = "found";
                    var container = $('#mainelement');
                    var scrollTo = $('#found');
                    var position = scrollTo.offset().top - container.offset().top + container.scrollTop();
                    container.scrollTop(position, 3000);
                    // x[i].style.border = "1px solid #C2C2B1";
                    x[i].classList.add("searchmessage");
                    // $('body').addClass("fixed-position");
                }
            }
        }
        else{

            for (i = 0; i < x.length; i++) {
                x[i].id=""
                x[i].style.backgroundColor = "transparent";
            }
            scrollToMyRef()
        }
        
    };

    return (
        <>
            <UserHeader id={props.username} />
            {/* Page content */}
            <Container className="p-0 mobile-min-mt only-pc " style={{overflow: 'hidden'}} fluid>
                <Row>
                    <Col className="bg-dc" lg="12" sm="12" md="12" xl="12" xs="12" >
                        <Card className={"shadow cardbg-" + props.theme}>
                            <CardHeader className={"cardbg-" + props.theme + " light-shadow  pb-1 pt-2 pl-1 pr-1 cardb-" + props.theme}>
                                <div style={{display: 'flex'}}>
                                    
                                    <Link style={{flex:1,display: 'flex'}} to={'/main/profile/'+userd.username}><CTooltip arrow title='View Profile' placement='top' >
                                    <Avatar className="ml-2" aria-label="recipe" src={process.env.REACT_APP_DOMAIN + userd.photo}>
                                        {aname}
                                        </Avatar></CTooltip><CTooltip arrow title='View Profile' placement='top' >
                                            <h1 className={"ml-3 textb-" + props.theme} >{userd.username}</h1></CTooltip></Link>
                                    {(searchopen?
                                    <div style={{flex:1,display: 'flex'}}>
                                        <Input placeholder='Search Messages' autoFocus onChange={handleOnChange} />
                                        <IconButton disableRipple onClick={()=>{setsearchopen(false)}}><Close /></IconButton>
                                    </div>
                                    :
                                        <CTooltip arrow title='Search Messages' placement='top' ><IconButton disableRipple onClick={()=>{setsearchopen(true)}} ><Search /></IconButton></CTooltip>
                                    )}

                                    <CTooltip arrow title='Refresh Chats' placement='top' ><IconButton disableRipple color="" className="ml-" size="medium" aria-label="add" onClick={fetchChats} >
                                        <Refresh />
                                    </IconButton></CTooltip>
                                </div>
                            </CardHeader>
                            <CardBody className="pt-0 pl-0 pr-0 pb-1">
                                <div ref={chatContainer} id='mainelement' className={"no-scrollbar lbgl-" + props.theme} style={{ minHeight: '550px', maxHeight: '550px', backgroundColor: '', overflowY: 'scroll' }} scrollTop={900}>
                                    {(chatl ?
                                        <div className="full-width text-center"><p><CircularProgress size="30px" className={"mt-2 mb-2 textb-" + props.theme} /></p></div>
                                        :
                                        (data3 === undefined ?
                                            <div><CircularProgress size="20px" /></div>
                                            :
                                            data3.map(function (resp, index) {
                                                if (resp.image !== null) {
                                                    if (resp.sender !== undefined) {
                                                        if (resp.sender.id === props.username) {
                                                            return (
                                                                <div className='main-message'><Message date={resp.date} offer={linkify(resp.message)} state='right' type='image' image={process.env.REACT_APP_DOMAIN + "" + resp.image} timestr={moment(resp.time, "HH:mm:ss").format("hh:mm A")} /></div>
                                                                // <a href={process.env.REACT_APP_DOMAIN + "" + resp.image} target="_blank" rel="noreferrer" ><MessageBox position={'right'} type={'text'} text={<img alt='message_image' style={{ maxHeight: '300px' }} src={process.env.REACT_APP_DOMAIN + "" + resp.image} />} dateString={moment(resp.time, "HH:mm:ss").format("hh:mm A")} /></a>
                                                            )
                                                        }
                                                        else {
                                                            return (
                                                                <div className='main-message'><Message date={resp.date} offer={linkify(resp.message)} state='left' type='image' image={process.env.REACT_APP_DOMAIN + "" + resp.image} timestr={moment(resp.time, "HH:mm:ss").format("hh:mm A")} /></div>
                                                                // <a href={process.env.REACT_APP_DOMAIN + "" + resp.image} target="_blank" rel="noreferrer" ><MessageBox position={'left'} type={'photo'} text={<img alt='message_image' style={{ maxHeight: '300px' }} src={process.env.REACT_APP_DOMAIN + "" + resp.image} />} dateString={moment(resp.time, "HH:mm:ss").format("hh:mm A")} /></a>
                                                            )
                                                        }
                                                    }
                                                }
                                                else if (resp.file !== null) {
                                                    var cfname = resp.file.substring(21, resp.file.length)
                                                    if (resp.sender !== undefined) {
                                                        if (resp.sender.id === props.username) {
                                                            return (
                                                                <div className='main-message'><Message date={resp.date} offer={cfname} state='right' type='file' file={process.env.REACT_APP_DOMAIN + "" + resp.file} timestr={moment(resp.time, "HH:mm:ss").format("hh:mm A")} /></div>
                                                                // <a href={process.env.REACT_APP_DOMAIN + "" + resp.file} target="_blank" rel="noreferrer" ><MessageBox position={'right'} type={'file'} text={cfname} dateString={moment(resp.time, "HH:mm:ss").format("hh:mm A")} /></a>
                                                            )
                                                        }
                                                        else {
                                                            return (
                                                                <div className='main-message'><Message date={resp.date} offer={cfname} state='left' type='file' file={process.env.REACT_APP_DOMAIN + "" + resp.file} timestr={moment(resp.time, "HH:mm:ss").format("hh:mm A")} /></div>
                                                                // <a href={process.env.REACT_APP_DOMAIN + "" + resp.file} target="_blank" rel="noreferrer" ><MessageBox position={'left'} type={'file'} text={cfname} dateString={moment(resp.time, "HH:mm:ss").format("hh:mm A")} /></a>
                                                            )
                                                        }
                                                    }
                                                }
                                                else {
                                                    if (resp.sender !== undefined) {
                                                        if (resp.sender.id === props.username) {
                                                            return (
                                                                <div className='main-message'><Message date={resp.date} offer={linkify(resp.message)} state='right' type='message' timestr={moment(resp.time, "HH:mm:ss").format("hh:mm A")} /></div>
                                                                // <MessageBox position={'right'} type={'text'} text={<p className="mt-1 mb-1">{linkify(resp.message)}</p>} dateString={moment(resp.time, "HH:mm:ss").format("hh:mm A")} />
                                                            )
                                                        }
                                                        else {
                                                            return (
                                                                <div className='main-message'><Message date={resp.date} offer={linkify(resp.message)} state='left' type='message' timestr={moment(resp.time, "HH:mm:ss").format("hh:mm A")} /></div>
                                                                // <MessageBox position={'left'} type={'text'} text={<p className="mt-1 mb-1">{linkify(resp.message)}</p>} dateString={moment(resp.time, "HH:mm:ss").format("hh:mm A")} />
                                                            )
                                                        }
                                                    }

                                                }
                                                return (null)
                                            })
                                        )
                                    )}
                                    <div style={{ clear: "both", backgroundColor: '', height: '1px', width: '100%' }} ref={titleRef2}></div>
                                </div>
                                <CardFooter className={"pb-0 pt-1 pr-0 cardbg-" + props.theme}>
                                    <Row>
                                        <Col xl="2" lg="3" sm="3" xs="4" md="3" className="bg-yellowc p-0" >
                                            <CTooltip arrow title='Send Emoji' placement='top' ><Button color="link" className={"border-0 nobg-hover p-3 mr-0 bg-cyanc texts-" + props.theme} onClick={openEmoji} ><Emoji /></Button></CTooltip>
                                            <CTooltip arrow title='Attachments' placement='top' ><Button color="link" className={"border-0 nobg-hover p-3 mr-0 bg-cyanc texts-" + props.theme} onClick={openFile} ><File /></Button></CTooltip>
                                        </Col>
                                        <Popover
                                            id="mouse-over-popover"
                                            className={classes.popover + "popp"}
                                            classes={{
                                                paper: classes.paper,   
                                            }}
                                            open={emoji}
                                            anchorEl={anchorEl}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            }}
                                            onClose={closeEmoji}
                                            disableRestoreFocus
                                        >
                                            <Picker onEmojiClick={onEmojiClick} />

                                        </Popover>
                                        <Popover
                                            id="mouse-over-popover"
                                            className={classes.popover + "popp"}
                                            classes={{
                                                paper: classes.paper2,
                                            }}
                                            open={file}
                                            anchorEl={anchorEl2}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            }}
                                            onClose={closeFile}
                                            disableRestoreFocus
                                        >
                                            <CTooltip arrow title='Send Image' placement='top' ><Button color="link" className={"border-0 mt-2 ml-2 texts-" + props.theme} onClick={handleImage}><Image /></Button></CTooltip>
                                            <input onChange={handleChangeFile} type="file" ref={hiddenFileInput} accept=".doc,.docx" style={{ display: 'none' }} />
                                            <CTooltip arrow title='Send File' placement='top' ><Button color="link" className={"border-0 mt-2 ml-2 texts-" + props.theme} onClick={handleFile}><Afile /></Button></CTooltip>
                                            <input onChange={handleChangeImage} type="file" accept="image/*" ref={hiddenImageInput} style={{ display: 'none' }} />
                                        </Popover>
                                        <Col xl="8" lg="8" sm="7" xs="5" md="7" className="bg-tealc p-0">
                                            <Input style={{ height: '100%' }} placeholder="Send Something" autoFocus value={mess} onChange={handleMess} onKeyDown={handleEnter} type="text" className={"form-control-alternative inputbg-" + props.theme} />
                                        </Col>
                                        <Col xl="1" lg="1" sm="1" xs="1" md="1" className="bg-greenc" >
                                            <CTooltip arrow title='Send Message' placement='top' ><Button color="link" onClick={handleSend} className={"border-0 p-3 bg-yellowc nobg-hover texts-" + props.theme} disabled={loading} >{(loading ? <CircularProgress size="20px" />: <Send />)}</Button></CTooltip>
                                        </Col>
                                    </Row>
                                </CardFooter>
                            </CardBody>
                        </Card>
                        <Modal
                            className="modal-dialog-centered"
                            isOpen={filemodal}
                            toggle={handleClosefilemodal}>
                            <div className="modal-header">
                                <h2 className="modal-title mt-2 mb-0" id="modal-title-default">  Send File </h2>
                                <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={handleClosefilemodal}> <span aria-hidden={true}>×</span> </button>

                            </div>
                            <div className="modal-header text-muted mt-0 mb-0">
                                <small>Send <span style={{ fontWeight: 'bold' }}>{filename}</span> to <span style={{ fontWeight: 'bold' }}>{userd.username}</span></small>
                            </div>
                            <Row className="modal-body bg-orangec">
                                <Col lg="6">
                                    <FormGroup>
                                        <div className="mt-2">
                                            <a href={sfile} target="_blank" rel="noreferrer" className="bg-white point underline-hover pl-2 pt-2 pb-2 pr-2 form-control-alternative text-default">
                                                <Afile className="mr-2 mt--1" />{(filemodal ? filename : "No File uploaded")}
                                            </a>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="modal-footer bg-tealx pt-0">
                                <Button color="inf" data-dismiss="modal" type="button" onClick={handleClosefilemodal}> Close </Button>
                                <Button className="ml-auto" color="info" onClick={handleSendfile} outline> Send </Button>
                            </div>
                        </Modal>
                        <Modal
                            className="modal-dialog-centered"
                            isOpen={imagemodal}
                            toggle={handleCloseimagemodal}>
                            <div className="modal-header">
                                <h2 className="modal-title mt-2 mb-0" id="modal-title-default">  Send Image </h2>
                                <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={handleCloseimagemodal}> <span aria-hidden={true}>×</span> </button>

                            </div>
                            <div className="modal-header text-muted mt-0 mb-0">
                                <small>Send <span style={{ fontWeight: 'bold' }}>{imagename}</span> to <span style={{ fontWeight: 'bold' }}>{userd.username}</span></small>
                            </div>
                            <Row className="modal-body bg-orangec">
                                <Col lg="6">
                                    <FormGroup>
                                        <div className="mt-2">
                                            <a href={aimage} target="_blank" rel="noreferrer" className="bg-white point underline-hover pl-2 pt-2 pb-2 pr-2 form-control-alternative text-default">
                                                <img alt='message_image' src={aimage} style={{ maxHeight: '300px' }} />
                                            </a>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="modal-footer bg-tealx pt-0">
                                <Button color="inf" data-dismiss="modal" type="button" onClick={handleCloseimagemodal}> Close </Button>
                                <Button className="ml-auto" color="info" onClick={handleSendimage} outline> Send </Button>
                            </div>
                        </Modal>
                    </Col>
                </Row>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};


export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        fullname: state.tempUser,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Profile);
